<template>
    <div>
        <h1 style="font-size: 24px; color: black;">游戏圈日报</h1>
        <div class="block" style="margin-top: 25px" >
            <span class="demonstration">日期：</span>
            <el-date-picker
                    v-model="queryData.timeDate"
                    type="daterange"
                    :clearable="false"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd">
            </el-date-picker>&emsp;&emsp;
            <el-button  type="primary" class="margin-left-10"  @click="query" >查询</el-button>
        </div>

        <h1>
            <el-table border :data="postReport"
                      :header-cell-style="{background:'#282828'}">
                <el-table-column prop="dt"  label="日期"></el-table-column>
                <el-table-column prop="postUser"  label="发帖用户数"></el-table-column>
                <el-table-column prop="post"  label="发帖数"></el-table-column>
                <el-table-column prop="squareExpUser"  label="广场曝光用户"></el-table-column>
                <el-table-column prop="postRate"  label="发帖率">
                    <template slot-scope="scope">
                        {{scope.row.postRate==null?'0.00%':(scope.row.postRate*100).toFixed(2)+'%'}}
                    </template>
                </el-table-column>
                <el-table-column prop="totalComments"  label="总评论数"></el-table-column>
                <el-table-column prop="totalCommentsUser"  label="总评论人数"></el-table-column>
                <el-table-column prop="totalUps"  label="总点赞数"></el-table-column>
                <el-table-column prop="totalShares"  label="总分享数"></el-table-column>
                <el-table-column prop="interactUser"  label="互动用户数"></el-table-column>
                <el-table-column prop="interactRate"  label="互动率">
                    <template slot-scope="scope">
                    {{scope.row.interactRate==null?'0.00%':(scope.row.interactRate*100).toFixed(2)+'%'}}
                    </template>
                </el-table-column>
                <el-table-column prop="totalQuoteTopic"  label="话题总引用数"></el-table-column>
                <el-table-column prop="totalQuoteTopicUser"  label="话题总用户数"></el-table-column>
                <el-table-column prop="topicParticipationRate"  label="话题渗透率">
                    <template slot-scope="scope">
                    {{scope.row.topicParticipationRate==null?'0.00%':(scope.row.topicParticipationRate*100).toFixed(2)+'%'}}
                    </template>
                </el-table-column>

            </el-table>
            <el-row>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryInfo.pagenum"
                        :page-sizes="[10,20,30,50]"
                        :page-size="queryInfo.pagesize"
                        layout="total, sizes, prev, pager, next"
                        :total="queryInfo.total">
                </el-pagination>
            </el-row>
        </h1>
    </div>
</template>

<script>
    import {
        searchPostReport,
    }from "@/http/api";
    import utils from '@/utils'
    export default {
        name: "PostReport",
        data(){
            return{
                postReport:[],
                queryData:{
                    timeDate:['',''],
                },
                queryTrueData:{
                    startTime:'',
                    endTime:'',
                },
                queryInfo:{
                    pagesize:10,
                    pagenum:1,
                    total:0,
                },
            }
        },
        methods:{
            handleSizeChange(newSize){
                this.queryInfo.pagesize=newSize;
                this.searchPostReport();
            },
            handleCurrentChange(newPage){
                this.queryInfo.pagenum=newPage;
                this.searchPostReport();
            },
            query(){
                this.queryInfo.pagenum=1;
                this.searchPostReport();
            },
            searchPostReport(){
                if (this.queryData.timeDate===null){
                    this.queryData.timeDate=['',''];
                }
                this.queryTrueData.startTime= this.queryData.timeDate[0];
                this.queryTrueData.endTime=this.queryData.timeDate[1];
                this.queryTrueData.size=this.queryInfo.pagesize;
                this.queryTrueData.page=this.queryInfo.pagenum;
                searchPostReport(this.queryTrueData).then(resp=>{
                    this.postReport=resp.data.info.content;
                    this.queryInfo.total=resp.data.info.totalElements;
                });
            },
        },
        created(){
            this.queryData.timeDate=[utils.TodayUtil.getWeekAgo(),utils.TodayUtil.getToday()];
            this.searchPostReport();
        }
    }
</script>

<style scoped>

</style>
